import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";
import { applyStoredTheme } from "@/shared/theme";

applyStoredTheme();

const host = document.getElementById("root");
if (!host) throw new Error("Корневой узел #root не найден");

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
